const AccountActionTypes = {
  LOAD_ACCOUNT_REQUEST: 'LOAD_ACCOUNT_REQUEST',
  LOAD_ACCOUNT_SUCCESS: 'LOAD_ACCOUNT_SUCCESS',
  LOAD_ACCOUNT_FAILURE: 'LOAD_ACCOUNT_FAILURE',
  ACCOUNT_LOGOUT: 'ACCOUNT_LOGOUT',
};
export default AccountActionTypes;
